export enum DateiTyp {
  VERORDNUNG = 2,
  BETRIEBSGROESSENKLASSEN = 3,
  NUTS_ZWEI_REGIONEN = 4,
}
